<template>
	<div class="container-fluid pt-5 pb-5 bg1">
		<div class="container bg2" id="link1">
			<div class="tips pt-4 pb-4 pl-3 pr-2">
				<input id="fid_lk" type="hidden" :value="fid" />
				<input id="fout_lk" type="hidden" :value="fout" />
				<a href="javascript:void(0)" @click="toback">考试测评</a><span class="s1">|</span><span class="s2">{{doTestList.title}}</span>
				<a href="javascript:void(0);" class="progress-time">
					<i class="ico-time-control"></i>
					<span data-left="2592000" data-time="0" class="time-text" style="font-size: 20px;">{{str}}</span>
				</a>
				<a href="javascript:void(0);" class="progress-up" @click="uppaper">
					<i class="fa fa-check-square"></i> 提交试卷
					<span class="s1">|</span>
				</a>
			</div>
			<div class="content_item pt-3" v-if="!isCode">
				<div v-for="(item,key) of doTestList.list" :key="item.id" v-show="item.id==temp">
					<div class="subject-title-box">
						<div class="answer-progress">{{key + 1}}/{{doTestList.total}}</div>
						<div class="subject-title" v-if="item.type==1">[编程题（第1部分）/{{item.score}}分]</div>
						<div class="subject-title" v-if="item.type==2">[编程题（第2部分）/{{item.score}}分]</div>
					</div>
					<div class="subject-main">
						<div class="subject-content">
							<div class="subject-question">
								{{item.title}}
							</div>
							<div class="subject-question-desc" v-html="item.titleDesc">
							</div>
						</div>
						<div class="subject-action clearfix" v-if="!isUpdate">
							<div class="subject-opr">
							</div>
							<div class="subject-next">
								<a class="btn next-btn" v-on:click="cd()">开始编程</a>
							</div>
						</div>
					</div>
				</div>
				<div class="answer-sheet-box open" v-if="!isUpdate">
					<div class="answer-sheet-type clearfix">
						<i class="fa fa-reorder">&nbsp;</i>
						<span v-for="value of doTestList.tag">{{value}}</span>
					</div>
					<div class="card-fold">答题卡</div>
					<ul class="answer-sheet-num clearfix">
						<li v-for="(item,key) of doTestList.list">
							<a href="javascript:void(0);" v-bind:data-id="item.id" v-on:click="qh(item.id,item.demoOut)" class="answer_links" :class="{answering_num:item.id==temp,answer_done:item.myanswer}">
								{{key + 1}}
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="content_item pt-3 clearfix" v-if="isCode">
				<div class="clearfix">
					<div class="clearfix cpp-left" v-for="(item,key) of doTestList.list" :key="item.id" v-show="item.id==temp">
						<div class="subject-title-box">
							<div class="answer-progress">{{key + 1}}/{{doTestList.total}}</div>
							<div class="subject-title" v-if="item.type==1">[编程题（第1部分）/{{item.score}}分]</div>
							<div class="subject-title" v-if="item.type==2">[编程题（第2部分）/{{item.score}}分]</div>
						</div>
						<div class="">
							<div class="cpp-content">
								<div class="cpp-question">
									{{item.title}}
								</div>
								<div class="cpp-question-desc" v-html="item.titleDesc">
								</div>
								<div class="cpp-in">
									输入
								</div>
								<div class="cpp-in-desc" v-html="item.cppIn">
								</div>
								<div class="cpp-in">
									输出
								</div>
								<div class="cpp-in-desc" v-html="item.cppOut">
								</div>
								<div class="cpp-in">
									样例输入
								</div>
								<div class="demo-in-desc" v-html="item.demoIn">
								</div>
								<div class="cpp-in">
									样例输出
								</div>
								<div class="demo-out-desc" v-html="item.demoOut">
								</div>
							</div>
						</div>
					</div>
					<div class="cpp-right clearfix">
						<div>
							<codemirror v-model="code" :options="options"></codemirror>
						</div>
						<div>
							<ul class="tabs clearfix">
								<li class="li-tab" v-for="(item,index) in tabsParam" @click="toggleTabs(index)" :class="{active:index!=nowIndex}">{{item}}</li>
								<li class="li-tab li-tab-3" @click="insertcode">保存</li>
								<li class="li-tab li-tab-1" v-on:click="runcode">运行</li>
							</ul>
							<div class="divTab" v-show="nowIndex===0" style="position: relative;">
								<div class="text-cs clearfix">
									<input class="std-input" id="stdin" />
									<div id="output" class="clearfix std-out"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="answer-sheet-box open clearfix" v-if="!isUpdate">
					<div class="answer-sheet-type clearfix">
						<i class="fa fa-reorder">&nbsp;</i>
						<span v-for="value of doTestList.tag">{{value}}</span>
					</div>
					<div class="card-fold">答题卡</div>
					<ul class="answer-sheet-num clearfix">
						<li v-for="(item,key) of doTestList.list">
							<a href="javascript:void(0);" v-bind:data-id="item.id" v-on:click="qh2(item.id,item.demoOut)" class="answer_links" :class="{answering_num:item.id==temp,answer_done:item.myanswer}">
								{{key + 1}}
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import qs from 'qs'
	import { codemirror } from 'vue-codemirror'
	// 核心样式
	import 'codemirror/lib/codemirror.css'
	// 引入主题后还需要在 options 中指定主题才会生效
	import 'codemirror/theme/rubyblue.css'
	import 'codemirror/mode/clike/clike.js'

	let Base64 = require('js-base64').Base64;
	export default {
		name: 'DotestContent',
		props: ["doTestList", "fid", "fout", "paperList"],
		data() {
			return {
				doTestList: [],
				paperList: [],
				fid: null,
				fout: null,
				temp: null,
				maxtime: 7200,
				h: 0, //定义时，分，秒并初始化为0；
				m: 0,
				ms: 0,
				s: 0,
				time: 0,
				str: '',
				mytime: '',
				isUpdate: false,
				totalScore: 0,
				score: 0,
				testId: null,
				dout: null,
				isCode: false,
				tabsParam: ['控制台'], //（这个也可以用对象key，value来实现）
				nowIndex: 0, //默认第一个tab为激活状态
				code: '', // 编辑器绑定的值
				// 默认配置
				options: {
					tabSize: 4, // 缩进格式
					theme: 'rubyblue', // 主题，对应主题库 JS 需要提前引入
					mode: 'text/x-c++src',
					lineNumbers: true, // 显示行号
					line: true,
					styleActiveLine: true, // 高亮选中行
					hintOptions: {
						completeSingle: true // 当匹配只有一项的时候是否自动补全
					}
				}
			}
		},
		methods: {
			cd() {
				this.isCode = true
				document.getElementById('link1').scrollIntoView()
				var that = this
				var tkId = that.temp
				var paperId = that.paperList[0].id
				var formParams = qs.stringify({
					tkId: tkId,
					paperId: paperId
				})
				axios.post('/itmswcn/learn/cpp/answer/query', formParams)
					.then(this.querycodeSucc)
			},
			uppaper() {
				var paperId = this.paperList[0].id
				var formParams = qs.stringify({
					id: paperId
				})
				axios.post('/itmswcn/learn/cpp/paper/update', formParams)
					.then(this.uppaperSucc)
			},
			uppaperSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
				}
			},
			querycodeSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.code = data.answer
				}
			},
			qh(t, a) {
				this.temp = t
				this.dout = a
				this.code = ''
				$('#stdin').val('')
				$('#output').html('')
			},
			qh2(t, a) {
				this.temp = t
				this.dout = a
				this.code = ''
				$('#stdin').val('')
				$('#output').html('')
				this.cd()
			},
			runcode() {
				var cmd = "g++ -std=c++17 -O2 -Wall -pedantic -pthread main.cpp && ./a.out";
				var src = this.code;
				var stdin = $('#stdin').val();
				var _this = this;
				if(src != "") {
					$.post("https://runcode-api2-ng.dooccn.com/compile2", {
						language: 7,
						code: Base64.encode(src),
						stdin: stdin
					}, function(data) {
						_this.printCppCodeRusult(data.output, data.errors);
					});
				}
			},
			printCppCodeRusult(output, errors) {
				var dout = this.dout
				if(errors != null && errors.length > 0) {
					output = errors;
					this.score = 0;
					$('#output').html(output);
				} else {
					output = output.replace("官方网站:http://www.dooccn.com", "").replace(/(^\s*)|(\s*$)/g, "");
					if(output == dout) {
						this.score = 12
						$('#output').html('输出正确：' + output);
					} else {
						this.score = 0
						$('#output').html('输出错误：' + output);
					}
				}

			},
			insertcode() {
				var that = this
				var paperId = that.paperList[0].id
				var tkId = that.temp
				var score = this.score
				var code = this.code
				$.confirm({
					title: '',
					content: '<span class="itmsw_ft_1"><i class="fa fa-info-circle"></i> 您确定要保存代码吗？</span>',
					theme: 'modern',
					closeIcon: false,
					animation: 'scale',
					type: 'blue',
					boxWidth: '380px',
					useBootstrap: false,
					backgroundDismiss: false,
					buttons: {
						yes: {
							text: '确认', // text for button
							btnClass: 'itmsw_bt_confirm_1', // class for the button
							keys: ['y'], // keyboard event for button
							isHidden: false, // initially not hidden
							isDisabled: false, // initially not disabled
							action: function(yesButton) {
								var formParams = qs.stringify({
									paperId: paperId,
									tkId: tkId,
									score: score,
									answer: code
								})
								axios.post('/itmswcn/learn/cpp/answer/update', formParams)
									.then(this.updatecodeSucc)
							}
						},
						no: {
							text: '取消', // text for button
							btnClass: 'itmsw_bt_confirm_2', // class for the button
							keys: ['n'], // keyboard event for button
							isHidden: false, // initially not hidden
							isDisabled: false, // initially not disabled
							action: function(noButton) {}
						}
					}
				});
			},
			updatecodeSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
				}
			},
			ck(item) {
				var el = event.currentTarget
				$(el).addClass("selected").siblings().removeClass("selected")
				$(el).find(".radio").addClass("checked")
				$(el).siblings().find(".radio").removeClass("checked")
				item.myanswer = $(el).data("tag")
				if(item.myanswer == item.answer) {
					item.aflag = true
				} else {
					item.aflag = false
				}
			},
			ck2(item) {
				var el = event.currentTarget
				if($(el).attr("class").indexOf("selected") == -1) {
					$(el).addClass("selected")
					$(el).find(".checkbox").addClass("checked")
				} else {
					$(el).removeClass("selected")
					$(el).find(".checkbox").removeClass("checked")
				}
				var arr = []
				$.each($(el).parent().find(".selected"), function() {
					arr.push($(this).data("tag"))
				})
				item.myanswer = arr.join(",")
				if(item.myanswer == item.answer) {
					item.aflag = true
				} else {
					item.aflag = false
				}
			},
			timer() { //定义计时函数
				if(this.maxtime >= 0) {
					this.m = Math.floor(this.maxtime / 60);
					this.s = Math.floor(this.maxtime % 60);
					this.maxtime--;
				}
				this.str = this.toDub(this.m) + ":" + this.toDub(this.s);
			},
			start() { //开始
				this.time = setInterval(this.timer, 1000);
			},

			stop() { //暂停
				clearInterval(this.time);
			},
			toDub(n) { //补0操作
				if(n < 10) {
					return "0" + n;
				} else {
					return "" + n;
				}
			},
			toback() {
				this.$router.push({
					path: '/robot/test'
				})
			},
			toggleTabs(index) {
				this.nowIndex = index;
			}
		},
		mounted() {
			document.getElementById('link1').scrollIntoView()
			this.start()
		},
		updated() {
			if(!this.temp) {
				this.temp = $("#fid_lk").val()
				this.dout = $("#fout_lk").val()
			}
		},
		components: {
			codemirror
		}
	}
</script>

<style lang="scss" scoped>
	ol,
	ul {
		list-style: none;
	}
	
	.content_item {
		position: relative;
	}
	
	.cpp-left {
		float: left;
		padding-left: 20px;
		padding-top: 10px;
		width: 350px;
		margin-bottom: 30px;
		.cpp-question {
			font-size: 18px;
			margin-bottom: 8px;
			font-family: "microsoft yahei";
			letter-spacing: 1px;
			font-weight: 600;
		}
		.cpp-question-desc {
			font-size: 16px;
			margin-bottom: 18px;
			font-family: "microsoft yahei";
			letter-spacing: 1px;
			line-height: 1.8rem;
			width: 300px;
		}
		.cpp-in {
			font-size: 16px;
			margin-bottom: 5px;
			font-family: "microsoft yahei";
			letter-spacing: 1px;
			font-weight: 600;
		}
		.cpp-in-desc {
			font-size: 14px;
			margin-bottom: 18px;
			font-family: "microsoft yahei";
			letter-spacing: 1px;
			line-height: 1.8rem;
			width: 300px;
		}
		.demo-in-desc {
			font-size: 14px;
			margin-bottom: 18px;
			font-family: "microsoft yahei";
			letter-spacing: 1px;
			line-height: 1.8rem;
			width: 300px;
			background: #F0F0F0;
			padding: 3px 8px;
		}
		.demo-out-desc {
			font-size: 14px;
			margin-bottom: 18px;
			font-family: "microsoft yahei";
			letter-spacing: 1px;
			line-height: 1.2rem;
			width: 300px;
			background: #F0F0F0;
			padding: 8px 8px;
		}
	}
	
	.cpp-right {
		float: right;
		width: 800px;
		margin-bottom: 30px;
		.li-tab {
			float: left;
			background: #F0F0F0;
			margin-right: 50px;
			margin-left: -40px;
			margin-top: 10px;
			font-size: 14px;
			letter-spacing: 1px;
			padding: 2px 5px;
			cursor: pointer;
		}
		.li-tab-1 {
			float: right;
			background: #357DCF;
			color: #FFFFFF;
			font-size: 14px;
			letter-spacing: 1px;
			padding: 2px 10px;
			cursor: pointer;
		}
		.li-tab-2 {
			float: right;
			background: #FF6C5F;
			color: #FFFFFF;
			font-size: 14px;
			letter-spacing: 1px;
			padding: 2px 10px;
			cursor: pointer;
		}
		.li-tab-3 {
			float: right;
			background: #357DCF;
			color: #FFFFFF;
			font-size: 14px;
			letter-spacing: 1px;
			padding: 2px 10px;
			cursor: pointer;
			margin-right: 0;
		}
		.text-cs {
			border: 0;
			border-radius: 5px;
			background-color: rgba(241, 241, 241, .98);
			width: 800px;
			min-height: 100px;
			padding: 10px;
			resize: none;
			outline: none;
			position: relative;
		}
		.std-input {
			outline-style: none;
			border: 0;
			border-radius: 3px;
			padding: 5px 0;
			width: 400px;
			font-size: 14px;
			font-weight: 400;
			font-family: "Microsoft soft";
		}
		.std-out {
			font-size: 14px;
			font-weight: 400;
			font-family: "Microsoft soft";
			line-height: 2rem;
		}
	}
	
	.content_item a {
		color: #000000;
		text-decoration: none;
	}
	
	.count_content {
		font-family: "microsoft yahei";
		font-size: 16px;
		line-height: 1.8;
		letter-spacing: 1px;
		.t {
			font-size: 18px;
			.s {
				font-size: 28px!important;
			}
		}
		.green {
			color: #1abc9c;
		}
		.orange {
			color: #ff431e;
		}
		.s {
			font-size: 24px;
			font-family: 'SimHei';
			padding-right: 3px;
		}
		.s1 {
			font-family: "microsoft yahei";
			font-size: 16px;
			padding-left: 50px;
			border-bottom: none;
			background: #fff url(../../../assets/img/rate.png) 20px 0 no-repeat;
			border-radius: 3px;
		}
		.s2 {
			font-size: 20px;
			font-family: 'SimHei';
			padding-right: 15px;
		}
		.t1,
		.t2,
		.t3 {
			border-bottom: none;
			background: #fff url(../../../assets/img/q-ico.png) 0 12px no-repeat;
			border-radius: 3px;
			padding-left: 30px;
		}
	}
	
	.subject-num-list {
		letter-spacing: -4px;
		margin-right: -10px;
		margin-left: -22px;
		margin-top: 5px;
		margin-bottom: -5px;
	}
	
	.subject-num-list li {
		letter-spacing: 0;
		display: inline-block;
		margin-right: 5px;
		margin-bottom: 15px;
	}
	
	.subject-num-list .correct-order a {
		background: #1abc9c;
		color: #fff;
	}
	
	.subject-num-list a {
		display: block;
		color: #333;
		font-size: 14px;
		width: 32px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		position: relative;
	}
	
	.subject-num-list .error-order a {
		background: #ff431e;
		color: #fff;
	}
	
	.subject-num-list a.done_hover,
	.subject-num-list a:hover {
		margin: -6px 0;
		height: 44px;
		line-height: 44px;
		font-size: 16px;
		color: #fff;
		text-decoration: none;
	}
	
	div.tips {
		border-bottom: 2px solid #F0F0F0;
		a {
			font-size: 20px;
			font-weight: 600;
			color: #333;
			text-decoration: none;
			cursor: pointer;
			letter-spacing: 2px;
			&:hover {
				color: #f39c12;
			}
		}
		.s1 {
			padding: 0 15px 0 8px;
		}
		.s2 {
			letter-spacing: 2px;
			font-size: 18px;
		}
	}
	
	.bg1 {
		background: #eee;
	}
	
	.bg2 {
		background: #FFFFFF;
	}
	
	.ico-time-control {
		display: inline-block;
		vertical-align: -6px;
		height: 28px;
		width: 28px;
		margin-right: 5px;
		background: url(../../../assets/img/ico-media.png) 0 -96px no-repeat;
	}
	
	.ico-time-control2 {
		display: inline-block;
		vertical-align: -6px;
		height: 28px;
		width: 28px;
		margin-right: 5px;
		background: url(../../../assets/img/ico-media.png) 0 -188px no-repeat;
	}
	
	.progress-time {
		color: #333;
		float: right;
	}
	
	.progress-up {
		color: #007bff !important;
		float: right;
		font-size: 16px !important;
		line-height: 30px;
	}
	
	.progress-up:hover {
		color: #f39c12 !important;
	}
	
	.subject-title-box {
		letter-spacing: 1px;
		padding-bottom: 20px;
	}
	
	.subject-title-box .answer-progress {
		background: #e5e5e5;
		float: left;
		padding: 0 5px;
		border-radius: 5px;
		font-size: 16px;
	}
	
	.subject-title-box .subject-title {
		background-position: 12px 0;
		margin-left: 40px;
		padding: 0 20px 0 47px;
		border-bottom: none;
		background: #fff url(../../../assets/img/q-ico.png) 16px 0 no-repeat;
		border-radius: 3px;
	}
	
	.subject-main {
		background: #fff;
		padding: 20px 20px 10px;
	}
	
	.subject-content {
		position: relative;
		margin-bottom: 20px;
	}
	
	.option-pic {
		height: 105px;
	}
	
	.subject-question {
		font-size: 17px;
		margin-bottom: 13px;
		font-family: "microsoft yahei";
		letter-spacing: 1px;
		font-weight: 600;
	}
	
	.subject-question-desc {
		font-size: 14px;
		margin-bottom: 10px;
		font-family: "microsoft yahei";
		letter-spacing: 1px;
		line-height: 1.8rem;
	}
	
	.subject-ans {
		font-family: "microsoft yahei";
		letter-spacing: 1px;
		.an {
			padding-right: 15px;
		}
		.my {
			padding-right: 10px;
		}
	}
	
	.is.orange {
		border-color: #ff6547;
	}
	
	.is.green {
		border-color: #1abc9c;
	}
	
	.subject-options {
		margin-bottom: 20px;
		border: 1px solid #d4d4d4;
		border-radius: 2px;
		padding: 12px 20px 13px;
		background: #fff;
		display: block;
		word-break: break-all;
	}
	
	.subject-options-update {
		margin-bottom: 20px;
		border: 1px solid #d4d4d4;
		border-radius: 2px;
		padding: 12px 20px 13px;
		background: #fff;
		display: block;
		word-break: break-all;
	}
	
	.subject-options-update:hover,
	.subject-options-update span:hover {
		cursor: default;
	}
	
	.subject-main .checkbox,
	.subject-main .radio {
		margin: 0;
		line-height: 2;
		cursor: pointer;
		font-size: 14px;
		text-align: left;
		display: inline-block;
		width: 100%;
	}
	
	.radio .icons {
		border-radius: 50%;
		border: 1px solid #ddd;
		vertical-align: -3px;
		width: 16px;
		height: 16px;
		background: #fff;
		display: inline-block;
		margin-right: 8px;
		line-height: normal;
		position: relative;
		text-align: left;
	}
	
	.checkbox .icons {
		border: 1px solid #ddd;
		vertical-align: -3px;
		width: 16px;
		height: 16px;
		background: #fff;
		display: inline-block;
		margin-right: 8px;
		border-radius: 2px;
		line-height: normal;
		position: relative;
		text-align: left;
	}
	
	.radio .imgicons,
	.checkbox .imgicons {
		vertical-align: -3px;
	}
	
	span.checkbox.checked .icons {
		vertical-align: -3px;
	}
	
	.checkbox.checked .icons {
		border: none;
	}
	
	.checkbox.checked .icons:before {
		content: "\f14a";
		color: #25bb9b;
		font-size: 18px;
		margin-top: -1px;
		margin-left: 0;
		font-family: FontAwesome;
	}
	
	.checkbox input,
	.radio input {
		display: none;
		outline: medium none!important;
	}
	
	span.checkbox .pre,
	span.radio .pre {
		display: inline-block;
		vertical-align: top;
		max-width: 850px;
		font-size: 16px;
		padding: 0;
		margin: 0;
		background: 0 0;
		border: none;
		font-family: "microsoft yahei";
		letter-spacing: 1px;
	}
	
	.subject-action {
		margin-bottom: 20px;
		font-size: 14px;
	}
	
	.subject-action .subject-next {
		float: right;
	}
	
	.subject-action .btn {
		margin-right: 10px;
	}
	
	.warning-btn {
		background: #ff6547;
		float: left;
		margin-right: 20px;
		color: #fff !important;
	}
	
	.warning-btn:hover {
		background: #ec7063;
		color: #fff;
	}
	
	.next-btn {
		background: #25bb9b;
		color: #fff !important;
	}
	
	.next-btn:hover {
		background: #22ae90;
		color: #fff;
	}
	
	.btn {
		display: inline-block;
		text-align: center;
		padding: 10px 0;
		width: 110px;
		color: #fff;
		font-size: 16px;
		border-radius: 3px;
		border: none 0;
		cursor: pointer;
		line-height: normal;
		outline: 0;
		white-space: nowrap;
		outline: none;
	}
	
	.answer-sheet-box {
		border-top: 1px dashed #ddd;
		padding: 20px;
		font-size: 16px;
		background: #fff;
	}
	
	.answer-sheet-type {
		float: right;
		font-size: 14px;
		color: #666;
		background: #f2f2f2;
		padding: 5px 10px;
	}
	
	.answer-sheet-type {
		float: right;
		font-size: 14px;
		color: #666;
		background: #f2f2f2;
		padding: 5px 10px;
	}
	
	.answer-sheet-type>span+span {
		border-left: 2px solid #aaa;
		padding-left: 13px;
		margin-left: 15px;
	}
	
	.open .answer-card-num,
	.open .answer-sheet-num {
		display: block;
	}
	
	.answer-sheet-num {
		margin-top: 15px;
		display: none;
		list-style: none;
		padding-left: 0;
	}
	
	.answer-sheet-num li {
		float: left;
		margin-right: 10px;
	}
	
	.answer-sheet-num a {
		position: relative;
		display: block;
		color: #c6d1dc;
		font-size: 16px;
		width: 40px;
		text-align: center;
		height: 40px;
		line-height: 40px;
		font-size: 17px;
	}
	
	.answer-sheet-num a.answering_num,
	.answer-sheet-num a.answer_done:hover,
	.answer-sheet-num a:hover {
		display: block;
		background: #59b59c;
		color: #fff;
	}
	
	.answer-sheet-num a.answer_done {
		color: #00bf8c;
	}
	
	.answer-sheet-num a.answering_num.answer_done {
		color: #FFFFFF;
	}
	
	.card-fold {
		font-size: 16px;
		line-height: 30px;
	}
	
	.subject-options:hover {
		background: #f3f3f3;
		text-decoration: none;
		border-color: #909090;
		.pre {
			color: #25bb9b;
		}
	}
	
	.subject-options.selected,
	.subject-options.selected:hover {
		border-color: #1abc9c;
		background: #fff;
	}
	
	.radio.checked .icons {
		border-color: #25bb9b;
	}
	
	.radio.checked .icons:before {
		border-radius: 50%;
		background: #25bb9b;
		width: 8px;
		height: 8px;
		display: inline-block;
		vertical-align: middle;
		content: "";
		position: absolute;
		left: 3px;
		top: 3px;
	}
	
	.btn:focus,
	.btn:active:focus,
	.btn.active:focus,
	.btn.focus,
	.btn:active.focus,
	.btn.active.focus {
		outline: none;
		border-color: transparent;
		box-shadow: none;
	}
	
	span.tag {
		font-size: 16px;
		padding: 0 8px 0 2px;
		font-family: Tahoma;
	}
</style>